/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketpagedetailunitprice4Inputs */

const en_ticketpagedetailunitprice4 = /** @type {(inputs: Ticketpagedetailunitprice4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price per ticket`)
};

const de_ticketpagedetailunitprice4 = /** @type {(inputs: Ticketpagedetailunitprice4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preis pro Ticket`)
};

/**
* | output |
* | --- |
* | "Price per ticket" |
*
* @param {Ticketpagedetailunitprice4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpagedetailunitprice4 = /** @type {((inputs?: Ticketpagedetailunitprice4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpagedetailunitprice4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpagedetailunitprice4(inputs)
	return de_ticketpagedetailunitprice4(inputs)
});
export { ticketpagedetailunitprice4 as "ticketPageDetailUnitPrice" }